<script setup>
import backIcon from "assets/graphics/icons/back-to-cards.svg";
const goBack = useGoBackDebounced();

const {
  handleClick: pressButton,
  isPressedDown: isButtonPressed,
  setPressed: setButtonPressed,
  unsetPressed: unsetButtonPressed
} = useButton(goBack);
</script>

<template>
  <div
    class="navigation-back"
    :class="{ 'pressed-kiosk-card': isButtonPressed }"
    @mousedown="setButtonPressed"
    @touchstart.prevent="setButtonPressed"
    @mouseup="unsetButtonPressed"
    @mouseleave="unsetButtonPressed"
    @touchend="pressButton"
    @click="pressButton"
  >
    <img
      :src="backIcon"
      class="back-icon"
    >
  </div>
</template>

<style scoped>
.navigation-back {
  position: absolute;
  bottom: calc(5rem + 190px);
  width: 80%;
  cursor: pointer;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pressed-kiosk-card {
  transform: scale(0.98);
}
</style>
